import { render, staticRenderFns } from "./PrintQRRelasiNew.vue?vue&type=template&id=6a390f0b"
import script from "./PrintQRRelasiNew.vue?vue&type=script&lang=js"
export * from "./PrintQRRelasiNew.vue?vue&type=script&lang=js"
import style0 from "./PrintQRRelasiNew.vue?vue&type=style&index=0&id=6a390f0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports